import clsx from "clsx";
import React, { useRef } from "react";
import useModal from "./useModal";
import useKeyboardNavigation from "../../../common/components/modals/useKeyboardNavigation";
import { ModalKey } from "../../types/common";

interface ModalProps extends ModalKey {
	additionalClasses?: string;
	alignContent?: string;
	title: string;
	children: React.ReactNode;
}

export function Modal({
	additionalClasses,
	alignContent,
	modalKey,
	title,
	children,
}: ModalProps) {
	const modalRef = useRef(null);
	const { openedModalsExist, onCloseModal } = useModal();
	useKeyboardNavigation(
		() => onCloseModal(modalKey),
		modalRef,
		openedModalsExist,
	);

	const classes = clsx("modal", additionalClasses, {
		open: openedModalsExist,
	});

	return (
		<div
			role="dialog"
			className={classes}
			aria-labelledby="modalTitle"
			aria-modal="true"
			ref={modalRef}
			onClick={() => onCloseModal(modalKey)} // To close modal on click outside
		>
			<div
				className={clsx("modal__container", alignContent)}
				onClick={(e) => e.stopPropagation()} // To not close modal on click inside
			>
				<header className="modal__header">
					<h2 id="modalTitle" className="modal__title">
						{title}
					</h2>
					<button
						type="button"
						className="btn-close"
						onClick={() => onCloseModal(modalKey)}
					>
						{`Close ${title} modal`}
					</button>
				</header>

				{children}
			</div>
		</div>
	);
}
